var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.title + ' ')+" "),(_vm.type == 'auto')?_c('span',[_vm._v(_vm._s(_vm.$t('auto_push')))]):_vm._e(),(_vm.type == 'moment')?_c('span',[_vm._v(_vm._s(_vm.$t('instant_push')))]):_vm._e(),(_vm.type == 'everyday')?_c('span',[_vm._v(_vm._s(_vm.$t('daily_push')))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }